import React from "react";
import { Platform } from "react-native";
import { defineMessages, injectIntl } from "react-intl";
import styled, { withTheme } from "styled-components/native";
import { localize } from "cci-utility";
import omit from "ramda/src/omit";
import BaseField from "./BaseField";
import Icon from "../icon/FontAwesomePro";

const messages = defineMessages({
  requiredFieldError: {
    id: "requiredFieldError",
    defaultMessage: "This field is required"
  }
});

const Input = styled.TextInput`
  font-family: ${props => props.theme.fontFamily};
  color: ${props =>
    props.color || props.theme.fieldFontColor || props.theme.fontColor};
  padding: ${props => props.paddings || props.theme.fieldPadding};
  text-align: ${props => props.align || "left"};
  flex: 1;
  min-width: 0;
  ${Platform.OS === "web" && "outline: none"};
`;

const FieldVeil = styled.TouchableOpacity`
  background-color: rgba(255, 255, 255, 0);
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2;
`;

const TextField = props => {
  const { intl, value, editable, onNoEditablePress, labelIcon } = props,
    // Remove the custom props for the React Native TextInput component
    inputProps = omit(
      [
        "leftComponent",
        "rightComponent",
        "intl",
        "label",
        "theme",
        "onNoEditablePress",
        "labelIcon",
        "labelNumberofLines",
        "backgroundColor"
      ],
      props
    );

  if (inputProps.placeholder) {
    // Translate the placeholder if a react-intl object was passed
    inputProps.placeholder = localize(intl, props.placeholder);
  }

  return (
    <BaseField {...props}>
      <Input
        {...inputProps}
        value={value}
        placeholderTextColor={props.theme.placeholderColor}
        underlineColorAndroid="transparent"
      />

      {labelIcon && (
        <Icon
          iconSize={15}
          color={props.theme.fontColor}
          name={labelIcon}
          margins="0 5px"
        />
      )}
      {/* When the field is not editable and the onNoEditablePress event has been specified, an invisible veil is rendered */}
      {editable === false && onNoEditablePress && (
        <FieldVeil onPress={() => onNoEditablePress()} />
      )}
    </BaseField>
  );
};

export default injectIntl(withTheme(TextField));
